import { ClientItem, SmartReplySuggestion } from 'owa-mail-store';
import { action } from 'satcheljs';

export default action('cacheSmartReplyDataAction', function cacheSmartReplyDataAction(
    item: ClientItem,
    validPropertyExists: boolean,
    smartReplies: SmartReplySuggestion[],
    loggableSmartReplies?: string[],
    smartReplyExtractionID?: string
) {
    return {
        item: item,
        validPropertyExists: validPropertyExists,
        smartReplies: smartReplies,
        loggableSmartReplies: loggableSmartReplies,
        smartReplyExtractionID: smartReplyExtractionID,
    };
});
